import { Raw } from '@/modules/common/helpers/api';
import { parseISO } from 'date-fns';

export type RawNotificationListResponse = Raw<
  NotificationListResponse,
  {
    // always specify existing raw entry types explititly
    notifications: RawUserNotification[];
  }
>;

export class NotificationListResponse {
  public status: string;
  public notifications: UserNotification[];
  public totalCount: number;
  public unreadCount: number;

  protected constructor(data: RawNotificationListResponse) {
    this.status = data.status;
    this.notifications = data.notifications.map(UserNotification.fromData);
    this.totalCount = data.totalCount;
    this.unreadCount = data.unreadCount;
  }

  public static fromData(data: RawNotificationListResponse): NotificationListResponse {
    return new NotificationListResponse(data);
  }
}

export type RawUserNotification = Raw<UserNotification>;

export class UserNotification {
  public id: string;
  public userID: string;
  public subject: string;
  public message: string;
  public category: string;
  public type: string | null;
  public fields: string | null;
  public createdAt: Date;
  public seenAt: Date | undefined;
  public readAt: Date | undefined;
  public actionedAt: Date | undefined;

  protected constructor(data: RawUserNotification) {
    this.id = data.id;
    this.userID = data.userID;
    this.subject = data.subject;
    this.message = data.message;
    this.category = data.category;
    this.type = data.type;
    this.fields = data.fields;
    this.createdAt = parseISO(data.createdAt);
    this.seenAt = data.seenAt === undefined ? undefined : parseISO(data.seenAt);
    this.readAt = data.readAt === undefined ? undefined : parseISO(data.readAt);
    this.actionedAt = data.actionedAt === undefined ? undefined : parseISO(data.actionedAt);
  }

  public static fromData(data: RawUserNotification): UserNotification {
    return new UserNotification(data);
  }
}
